import React, { useState, useContext, useEffect } from "react";
import {
	Box,
	Typography,
	Button,
	TextField,
	Grid,
	Divider,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { CreatorContext } from "../../context/CreatorContext";

import Product1 from "../../assets/product1.png";
import Product2 from "../../assets/product2.png";
import Product3 from "../../assets/product3.png";
import Product4 from "../../assets/product4.png";
import Product5 from "../../assets/product5.png";
import Product6 from "../../assets/product6.png";
import Product7 from "../../assets/product7.png";
import Product8 from "../../assets/product8.png";
import Product9 from "../../assets/product9.png";
import Product10 from "../../assets/product10.png";
import Product11 from "../../assets/product11.png";
import Product12 from "../../assets/product12.png";

import ProductRestaurant1 from "../../assets/showcases/restaurant/product1.JPG";
import ProductRestaurant2 from "../../assets/showcases/restaurant/product2.JPG";
import ProductRestaurant3 from "../../assets/showcases/restaurant/product3.JPG";
import ProductRestaurant4 from "../../assets/showcases/restaurant/product4.JPG";
import ProductRestaurant5 from "../../assets/showcases/restaurant/product5.JPG";
import ProductRestaurant6 from "../../assets/showcases/restaurant/product6.JPG";

import PaymentRestaurantEs from "../../assets/showcases/cart-restaurant-es.png";
import PaymentRestaurantEn from "../../assets/showcases/cart-restaurant-en.png";
import PaymentEcommerceEs from "../../assets/showcases/cart-ecommerce-en.png";
import PaymentEcommerceEn from "../../assets/showcases/cart-ecommerce-en.png";

const ShowcaseCart = ({
	useCoupon,
	sector,
	cartCreditCard,
	showReview,
	showPayment,
}) => {
	const { t } = useTranslation();
	const { creator } = useContext(CreatorContext);
	const [content, setContent] = useState([]);

	useEffect(() => {
		// Cargar productos específicos del sector
		const loadCartItems = () => {
			switch (sector) {
				case "ecommerce":
					setContent([
						{
							name: t("homeProducts.sunsetBlueSweater"),
							price: "€18.99",
							image: Product1,
							quantity: 1,
						},
						{
							name: t("homeProducts.oversizePinkSweater"),
							price: "€25.99",

							image: Product3,
							quantity: 1,
						},
					]);
					break;
				case "restaurant":
					setContent([
						{
							name: t("menuItems.pepperoniPizza"),
							price: "€8.00",
							image: ProductRestaurant1,
							quantity: 2,
						},
						{
							name: t("menuItems.cheesePizza"),
							price: "€8.00",

							image: ProductRestaurant2,
							quantity: 1,
						},
					]);
					break;
				default:
					setContent([]);
					break;
			}
		};
		loadCartItems();
	}, [sector, t]);

	// Función para calcular el total
	const calculateTotal = () => {
		switch (sector) {
			case "ecommerce":
				return "€44.98";
			case "restaurant":
				return "€44.98";

			default:
				return "€18";
		}
	};

	const CustomTextField = ({ label, type, multiline }) => {
		return (
			<Box sx={{ marginBottom: "8px" }}>
				{/* Etiqueta del campo */}
				{type === "outline" && (
					<Typography
						sx={{
							fontSize: "7px",
							color: "#888",
							marginBottom: "1px",
						}}
					>
						{label}
					</Typography>
				)}

				{type === "outline" && (
					<Box
						sx={{
							border: "1px solid #E0E0E0",
							backgroundColor: "#FFF",
							borderRadius: "4px",
							height: multiline ? "200px" : "30px",
							display: "flex",
							alignItems: "center",
							padding: "0 12px",
						}}
					>
						<Typography
							sx={{
								fontSize: "8px",
								color: "#C0C0C0",
							}}
						></Typography>
					</Box>
				)}

				{type === "filled" && (
					<Box
						sx={{
							backgroundColor: "#f2f2f2",
							borderRadius: "4px",
							height: "30px",
							display: "flex",
							alignItems: "center",
							padding: "0 12px",
							border: "1px solid transparent",
						}}
					>
						<Typography
							sx={{
								fontSize: "8px",
								color: "#C0C0C0",
							}}
						>
							{label}
						</Typography>
					</Box>
				)}

				{type === "standard" && (
					<Box
						sx={{
							borderBottom: "1px solid #E0E0E0",
							backgroundColor: "transparent",
							height: "30px",
							display: "flex",
							alignItems: "center",
							padding: "0 0px",
						}}
					>
						<Typography
							sx={{
								fontSize: "8px",
								color: "#C0C0C0",
							}}
						>
							{label}
						</Typography>
					</Box>
				)}
			</Box>
		);
	};

	function hexToRGBA(hex, opacity) {
		let r = parseInt(hex.slice(1, 3), 16);
		let g = parseInt(hex.slice(3, 5), 16);
		let b = parseInt(hex.slice(5, 7), 16);

		return `rgba(${r}, ${g}, ${b}, ${opacity})`;
	}

	return (
		<Box
			sx={{
				padding: 1,
				display: "flex",
				flexDirection: "column",
				justifyContent: "space-between",
				height: "100%",
				position: "relative",
			}}
		>
			<Grid container spacing={1}>
				{showReview && (
					<Typography sx={{ padding: 1, paddingBottom: 0 }} variant="body2">
						{cartCreditCard}
					</Typography>
				)}
				{content &&
					content.map((item, index) => (
						<Grid item xs={12} key={index}>
							<Box sx={{ display: "flex", alignItems: "center" }}>
								<Box
									sx={{
										flexShrink: 0,
										mr: 1,
										width: 50,
										height: 50,
										overflow: "hidden",
									}}
								>
									<img
										src={item.image}
										alt={item.name}
										style={{
											width: "100%",
											height: "100%",
											objectFit: "cover",
										}}
									/>
								</Box>
								<Box sx={{}}>
									<Typography variant="body" sx={{ fontSize: "8px" }}>
										{item.name}
									</Typography>
									<Typography variant="body2" sx={{ fontSize: "8px" }}>
										{item.quantity} x{" "}
										<span style={{ fontSize: "8px", fontWeight: "bold" }}>
											{item.price}
										</span>
									</Typography>
								</Box>
							</Box>
						</Grid>
					))}
			</Grid>

			<Box>
				{!showReview && useCoupon && (
					<>
						{creator.inputType === "input2" && (
							<Box sx={{ marginTop: 2 }}>
								<CustomTextField label={t("cart.coupon")} type="outline" />
							</Box>
						)}
						{creator.inputType === "input3" && (
							<Box sx={{ marginTop: 2 }}>
								<CustomTextField label={t("cart.coupon")} type="filled" />
							</Box>
						)}
						{creator.inputType === "input1" && (
							<Box sx={{ marginTop: 2 }}>
								<CustomTextField label={t("cart.coupon")} type="standard" />
							</Box>
						)}
					</>
				)}
				<Divider sx={{ marginTop: 1, marginBottom: 1 }}></Divider>
				<Box sx={{ display: "flex", justifyContent: "space-between" }}>
					<Typography
						variant="body2"
						sx={{
							fontSize: "8px",
							textTransform: "inherit",
						}}
					>
						{t("cart.shipping")}
					</Typography>
					<Typography
						variant="body2"
						sx={{ fontSize: "8px", textTransform: "inherit" }}
					>
						-
					</Typography>
				</Box>
				<Box
					sx={{
						display: "flex",
						justifyContent: "space-between",
						marginBottom: 1,
					}}
				>
					<Typography
						variant="body2"
						sx={{
							fontWeight: "bold",
							fontSize: "8px",
							textTransform: "inherit",
						}}
					>
						{t("cart.total")}
					</Typography>
					<Typography
						variant="body2"
						sx={{
							fontWeight: "bold",
							fontSize: "8px",
							textTransform: "inherit",
						}}
					>
						{calculateTotal()}
					</Typography>
				</Box>

				<Button
					variant="contained"
					fullWidth
					sx={{
						backgroundColor: creator ? creator.color : "#45A049",
						"&:hover": {
							backgroundColor: creator ? creator.color : "#45A049",
						},
						color: creator && creator.whiteTextButton ? "#ffffff" : "#000000",
						fontSize: "8px",
						borderRadius: creator && creator.buttonRounded ? "24px" : "0px",
						fontWeight: "bold",
						textTransform: "uppercase",
						height: "28px",
						width: "100%",
					}}
				>
					{t("cart.continueOrder")}
				</Button>
			</Box>
			{showPayment && (
				<Box
					sx={{
						position: "absolute",
						bottom: 0,
						left: 0,
						right: 0,
						top: 0,
						backgroundColor: hexToRGBA("#000000", 0.5),
					}}
				></Box>
			)}
			{showPayment && (
				<Box
					sx={{
						position: "absolute",
						bottom: "-25px",
						left: 0,
						right: 0,
						width: "100%",
					}}
				>
					<img
						src={
							t("language") === "es"
								? sector === "ecommerce"
									? PaymentEcommerceEs
									: PaymentRestaurantEs
								: sector === "ecommerce"
								? PaymentEcommerceEn
								: PaymentRestaurantEn
						}
						style={{ width: "100%" }}
						alt="payment"
					/>
				</Box>
			)}
		</Box>
	);
};

export default ShowcaseCart;
